<footer>
    <div [@animateFooter]>
        <ul class="footer-left-bar">
            <li>
                <a (click)='analyticsService.sendAnalyticEvent("click_github", "footer", "github")' href="https://github.com/AdlerMatos/portafolio-Adler" target='_blank'>
                    <i class="fab fa-github"></i>
                </a>
            </li>
            <li>
                <a (click)='analyticsService.sendAnalyticEvent("click_linkedin", "footer", "linkedin")' href="https://www.linkedin.com/in/adler-aviles-matos-atayauri-074b3835b/" target='_blank'>
                    <i class="fab fa-linkedin-in"></i>
                </a>
            </li>
            <li>
                <a (click)='analyticsService.sendAnalyticEvent("click_whatsapp", "footer", "whatsapp")' href="https://wa.me/51972230394" target='_blank'>
                    <i class="fab fa-whatsapp"></i>
                </a>
            </li>
            <li>
                <a (click)='analyticsService.sendAnalyticEvent("click_facebook", "footer", "facebook")' href="https://www.facebook.com/profile.php?id=61568893958402" target='_blank'>
                    <i class="fab fa-facebook-f"></i>
                </a>
            </li>
        </ul>
        <div class="footer-right-bar">
            <a (click)='analyticsService.sendAnalyticEvent("click_send_mail", "footer", "email")' href="mailto:amatoat@adlermatos.com" target='_blank'>amatoat&#64;adlermatos.com </a>
        </div>
    </div>

    <div class="footer-credits text-center" >
        <a (click)='analyticsService.sendAnalyticEvent("click_github_portfolio_andresjose", "footer", "click")' href="https://github.com/AdlerMatos/portafolio-Adler" target="_blank" rel="nofollow noopener noreferrer">
            <div>Built with Angular by Adler Aviles</div>
        </a>
        <a (click)='analyticsService.sendAnalyticEvent("click_github_portfolio_brittany", "footer", "click")' href="https://github.com/bchiang7/v4" target="_blank" rel="nofollow noopener noreferrer">
            <div class="mt-2">Designed by Brittany Chiang</div>
        </a>
    </div>

</footer>